export const AUDIO_FILE_FORMATS = [
    'audio/wav',
    'audio/vnd.wave',
    'audio/wave',
    'audio/x-wav',
    'audio/mpeg',
    'audio/MPA',
    'audio/mpa-robust',
    'audio/x-flac',
    'audio/flac',
    'audio/x-wavpack-correction',
    'audio/x-wavpack',
    'audio/x-aiff',
    'audio/aiff',
    'audio/ogg',
    'audio/vorbis-config',
    'application/ogg',
    'audio/vorbis',
    'audio/m4a',
    'audio/mp4',
    'audio/mpeg4-generic',
    'audio/x-m4a',
]

export const AUDIO_FILE_ACCEPT = AUDIO_FILE_FORMATS.join(',')

export const MAX_AUDIO_FILE_SIZE = 1024 ** 3
